import React from 'react';

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: React.ReactNode;
}): React.ReactElement {
  return (
    <div className="bo-empty bo-card">
      <h2 className="bo-empty-title">{title}</h2>
      {description ? <p className="bo-empty-desc">{description}</p> : null}
      {action ? <div className="bo-empty-action">{action}</div> : null}
    </div>
  );
}
